import React from 'react';
import styled from 'styled-components';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import FunnelUpdateStepContainer from '../../../../../containers/dashboards/cards/builder/funnels/StepContainer';
import FunnelUpdateStep from '../../../../../containers/dashboards/cards/builder/funnels/Step';
import FunnelUpdateStepFilter from '../../../../../containers/dashboards/cards/builder/funnels/StepFilter';
import ConversionMenu from './ConversionMenu';

const StyledFunnelUpdateStepContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid #999999;
  margin: 1px 1px 10px;
  background-color: #fff;
`;

const StyledFunnelUpdatePaneContainer = styled.div`
  overflow: auto;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;

  .item-list {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    padding: 20px;
    width: 100%;
  }
`;

const UpdateStep = (props) => {
  const { renderUpdateStepProps, unit } = props;
  const { isDragging, attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: renderUpdateStepProps.id,
  });

  const style = {
    opacity: isDragging ? 0.4 : undefined,
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <StyledFunnelUpdateStepContainer ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <FunnelUpdateStep
        {...props}
        {...renderUpdateStepProps}
        fromDashboard
        renderStepFilter={(renderStepFilterProps) => (
          <FunnelUpdateStepFilter {...renderStepFilterProps} unit={unit} />
        )}
      />
    </StyledFunnelUpdateStepContainer>
  );
};

const FunnelUpdatePaneContainer = (props) => {
  const { interval, onChangeInterval, unit } = props;

  return (
    <StyledFunnelUpdatePaneContainer>
      <ConversionMenu interval={interval} onChangeInterval={onChangeInterval} />
      <div className="item-list">
        <FunnelUpdateStepContainer
          renderUpdateStep={(renderUpdateStepProps) => (
            <UpdateStep renderUpdateStepProps={renderUpdateStepProps} unit={unit} {...props} />
          )}
          {...props}
        />
      </div>
    </StyledFunnelUpdatePaneContainer>
  );
};

export default FunnelUpdatePaneContainer;
